import { Link } from "react-router-dom";
import { Icon } from 'semantic-ui-react'

import { authProvider } from "../../auth";
import { useIsAdmin } from "../../hooks/isAdmin";
import { useIsPartnerLeadership } from "../../hooks/isPartnerLeadership";
import { PATHS } from "../../paths";

import styles from './Navigation.module.css';

function NavigationItem({ path, iconName, label }: { path: string, iconName: any, label: string }) {
  return (
    <Link to={path} className={styles.link}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Icon name={iconName} className={styles.icon} />
            <div>
                {label}
            </div>
        </div>
    </Link>
  );

}

function MobileNavigationFooter() {
  const isAdmin = useIsAdmin();
  const isPartnerLeadership = useIsPartnerLeadership();

  if (!authProvider.isAuthenticated()) {
      return null;
  }

  // Leadership users get their own stripped-down nav — the Leadership page has its own top bar
  if (isPartnerLeadership && !isAdmin) {
      return null;
  }

  return (
    <div className={styles.container}>
        <NavigationItem path={PATHS.CLASSES} iconName='group' label='Classes' />
        <NavigationItem path={PATHS.PEOPLE} iconName='user' label='People' />
        <NavigationItem path={PATHS.ALL_RECORDS} iconName='folder open' label='Records' />
        {isAdmin && <NavigationItem path={PATHS.ADMIN_SETTINGS} iconName='cog' label='Settings' />}
        <NavigationItem path={PATHS.LOGOUT} iconName='log out' label='Logout' />
    </div>
  );
}


export { MobileNavigationFooter };
